<template>
  <v-dialog
    transition="scale-transition"
    origin="center center"
    id="edit_contact_info"
    :max-width="554"
    :model-value="show"
    :fullscreen="$vuetify.display.xs"
    persistent
    z-index="10000"
  >
    <v-card class="text-left">
      <MessageDialog
        :show-dialog="showMsgDialog"
        :has-button-two="false"
        :type="updateDialogType"
        :title="updateDialogTitle"
        button-one-label="OK"
        :is-persistent="true"
        @buttonOneAction="closeEditContact"
      >
        <template v-slot:message>
          <span>
            <v-row mt-4 mb-4 justify="center">
              <v-col cols="10">
                {{ updateDialogMessage }}
                <v-tooltip location="top" max-width="200" v-if="!isSuccessEdit">
                  <template v-slot:activator="props">
                    <v-icon
                      color="blue"
                      :props
                      @blur="status = !status"
                      @focus="status = !status"
                      :icon="mdiInformationOutline"
                    />
                  </template>
                  <div>{{ errorNavigateDirectlyToEachPolicy }}</div>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row
              class="mb-2"
              justify="center"
              v-for="(policy, index) in updateDialogPolicies"
              :key="index"
            >
              <v-col cols="11">
                <div class="divHoldingPolicyForSuccessAndError">
                  {{ policy }}
                  <v-icon
                    color="green-darken-2"
                    class="moveToRight"
                    v-if="isSuccessEdit"
                    :icon="mdiCheckCircleOutline"
                  />
                  <v-icon
                    color="red-darken-2"
                    class="moveToRight"
                    v-if="!isSuccessEdit"
                    :icon="mdiAlertCircleOutline"
                  />
                </div>
              </v-col>
            </v-row>
          </span>
        </template>
      </MessageDialog>
      <v-card-text v-if="currentState === 'edit'" class="pl-0 pr-0 pt-0">
        <OnexAlert
          class="mb-0 ml-0 mr-0"
          :type="Notifications.error"
          dismissible="false"
          v-if="showAddressError"
        >
          {{ $t('L_the_addess_you_provided_cannot_be_verified_with_the_US_Postal') }}.
        </OnexAlert>
        <LoadingIndicator :loading="loading" />

        <!-- Start Edit Email -->
        <v-row justify="center" v-if="editingCategory == 'email'">
          <v-col cols="9" sm="10" md="9">
            <div
              class="heading_two mt-4 mb-2 font-size--20 text-center"
              v-html="$t('L_update_policy_email_address')"
            />
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16">
              {{ $t('L_We_may_use_this_email_to_contact_you_regarding_your_life_policy') }}
            </div>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16 font-weight-bold">
              {{ $t('L_note_this_update_will_only_apply_to_your_life_policy') }}
            </div>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <v-form id="form-policy-owner" ref="form">
              <OnexEmail
                data-comp-id="new-email"
                v-model="v$.emailAddress.$model"
                :label="$t('L_Enter_New_Email_Address')"
                required
              />
              <OnexEmail
                data-comp-id="confirm-new_email"
                v-model="v$.confirmEmailAddress.$model"
                :append-validations="[notSameAsEmail]"
                :label="$t('L_Confirm_New_Email_Address')"
                required
              />
            </v-form>
          </v-col>
        </v-row>
        <!-- End Edit Email -->
        <!-- Start Edit Phone -->
        <v-row justify="center" v-if="editingCategory == 'phone'">
          <v-col cols="9" sm="10" md="9">
            <h2 class="heading_two mt-4 mb-2 text-center">
              {{ $t('L_update_policy_phone_number') }}
            </h2>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16">
              {{ $t('L_We_may_use_this_phone_number_to_contact_you_regarding_your_life_policy') }}
            </div>
          </v-col>

          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16 font-weight-bold">
              {{ $t('L_note_this_update_will_only_apply_to_your_life_policy') }}
            </div>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <v-form id="form-policy-owner" ref="formPolicy">
              <OnexPhone
                data-comp-id="mobile-phone"
                v-model="v$.phoneNumber.$model"
                :label="$t('L_Enter_New_Phone_Number')"
                :maxLength="14"
                required
              />
              <OnexPhone
                data-comp-id="confirm-mobile-phone"
                v-model="v$.confirmPhoneNumber.$model"
                :label="$t('L_Confirm_New_Phone_Number')"
                :maxLength="14"
                :append-validations="[notSameAsPhoneValidation]"
                required
              />
            </v-form>
          </v-col>
        </v-row>
        <!-- End Edit Phone -->
        <!-- Start Address -->
        <v-row justify="center" v-if="editingCategory == 'address'">
          <v-col cols="9" sm="10" md="9">
            <h2 class="heading_two mt-4 mb-2 text-center">
              {{ $t('L_update_policy_home_address') }}
            </h2>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16">
              {{ addressHeaderLabel }}
            </div>
          </v-col>
          <v-col cols="9" sm="10" md="9">
            <div class="heading_two mt-4 mb-4 font-size--16 font-weight-bold">
              {{ $t('L_note_this_update_will_only_apply_to_your_life_policy') }}
            </div>
          </v-col>
          <!-- Start user Address entry -->
          <v-col v-if="isVerify" cols="11" sm="11" md="10">
            <v-form id="form-address" ref="formAddress">
              <OnexAddressLine1
                data-comp-id="update_contact_details_address_one"
                v-model="v$.address1Data.$model"
                :maxlen="35"
                :label="$t('L_Street_Address_-_Line_1')"
                :auto-capitalize="true"
                required
              />
              <OnexAddressLine2
                data-comp-id="update_contact_details_address_two"
                v-model="v$.address2Data.$model"
                :label="$t('L_Street_Address_-_Line_2_optional')"
                :auto-capitalize="true"
                :maxlen="35"
              />
              <OnexCity
                data-comp-id="update_contact_details_city"
                v-model="v$.cityData.$model"
                :label="$t('L_City')"
                required
              />
              <OnexState
                data-comp-id="update_contact_details_state"
                v-model="v$.stateData.$model"
                :country="currentPolicy.isCanadaPolicy ? Countries.CA : Countries.US"
                :label="currentPolicy.isCanadaPolicy ? $t('L_policy_province') : $t('L_State')"
                :include-territories="getTerritories"
                required
              />
              <OnexZip
                data-comp-id="update-contact-details-zip-code"
                v-model="v$.zipData.$model"
                :label="
                  currentPolicy.isCanadaPolicy ? $t('L_policy_postal_code') : $t('L_Zip_Code')
                "
                :maxlength="10"
                :country="currentPolicy.isCanadaPolicy ? Countries.CA : Countries.US"
                required
              />
            </v-form>
          </v-col>
          <!-- End of user Address entry -->
          <!-- Start of selecting user Entered Address Or USPS Suggested Address -->
          <div v-if="isVerify === false" cols="11" sm="11" md="10">
            <!--Start of User Typed Address and USPS verified address -->
            <v-col cols="12" md="12" class="pad-right-md pb-4">
              <h5 class="heading_five mb-2 font-weight-bold">
                {{ $t('L_address_you_entered') }}
              </h5>
              <v-col
                cols="12"
                pa-2
                pr-0
                :class="addressSelected === 'userEntered' ? 'blue-border' : 'gray-border'"
                @click="addressSelected = 'userEntered'"
              >
                <v-row>
                  <v-col>
                    <span class="font-size--14"> {{ address1Data }} {{ address2Data }} </span>
                    <br />
                    <span class="font-size--14">
                      {{ cityData }}, {{ stateData }}
                      {{ zipData.replace(/(\d{5})(\d{4})/, '$1-$2') }}
                    </span>
                  </v-col>
                  <v-col align-self-center>
                    <v-row justify="end">
                      <span
                        v-if="addressSelected !== 'userEntered'"
                        class="select-address pr-4 pt-2 font-weight-medium cursor-pointer"
                      >
                        {{ $t('L_select') }}
                      </span>
                      <span
                        v-if="addressSelected === 'userEntered'"
                        class="select-address pr-0 font-weight-medium"
                      >
                        <v-icon color="#2196f3" :icon="mdiCheckCircleOutline" />
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <!--End of User Typed Address and USPS verified address -->
            <!-- Start "The U.S. Postal Service recommended format"-->
            <v-col
              cols="12"
              md="12"
              pt-4
              pb-4
              class="pad-left-md"
              @click="addressSelected = 'useUsps'"
            >
              <h5 class="heading_five mb-2 font-weight-bold">
                {{ $t('L_The_US_Postal_Service_recommended_format') }}
              </h5>
              <v-col
                cols="12"
                pa-2
                pr-0
                :class="addressSelected === 'useUsps' ? 'blue-border' : 'gray-border'"
              >
                <v-row>
                  <v-col>
                    <span class="font-size--14">
                      {{ localUSPSFormattedAddress1 }}
                    </span>
                    <br />
                    <span class="font-size--14">
                      {{ localUSPSFormattedAddress2 }}
                    </span>
                  </v-col>
                  <v-col align-self-center>
                    <v-row justify="end">
                      <span
                        v-if="addressSelected !== 'useUsps'"
                        class="select-address pr-4 pt-2 font-weight-medium cursor-pointer"
                      >
                        {{ $t('L_select') }}
                      </span>
                      <span
                        v-if="addressSelected === 'useUsps'"
                        class="select-address pr-0 font-weight-medium"
                      >
                        <v-icon color="#2196f3" :icon="mdiCheckCircleOutline" />
                      </span>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
            <!-- End "The U.S. Postal Service recommended format:"-->
          </div>
          <!-- End of selecting user Entered Address Or USPS Suggested Address -->
        </v-row>
        <!-- End Address -->

        <!--Start Common -->
        <v-row justify="center" v-if="isMultiPolicy">
          <v-col cols="9" sm="10" md="9">
            <v-checkbox
              v-model="selectedUpdateAll"
              :label="checkBoxLabel"
              class="no-padding pa-0 ma-0"
              color="#063562"
            />
          </v-col>
        </v-row>
        <v-row justify="center" class="mb-12 ml-2 mr-2">
          <v-col cols="12" sm="8" md="8" mb-2>
            <OnexButton
              id="btn_save_changes"
              block
              color="primary"
              @click="clickSaveChanges()"
              :disabled="!enableSave || v$.$errors.length > 0"
              class="mb-2 btnFormat maxButtonWidth centerBtnHorizontally"
            >
              {{ $t('L_Save_Changes') }}
            </OnexButton>
          </v-col>
          <v-col cols="12" sm="8" md="8" class="mb-12">
            <OnexButton
              id="btn_close"
              block
              class="whitebutton btnFormat maxButtonWidth centerBtnHorizontally"
              @click="closeEditContact"
            >
              {{ $t('L_Cancel') }}
            </OnexButton>
          </v-col>
        </v-row>
        <!--End Common-->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import MessageDialog from '@/components/MessageDialog.vue';
import LoadingIndicator from '@/components/LoadingIndicator.vue';
import { defineComponent, type ComponentOptions } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { requiredIf } from '@vuelidate/validators';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { mapActions, mapState, mapStores } from 'pinia';
import { mdiAlertCircleOutline, mdiCheckCircleOutline, mdiInformationOutline } from '@mdi/js';
import {
  OnexButton,
  OnexEmail,
  OnexAddressLine1,
  OnexAddressLine2,
  OnexCity,
  OnexState,
  Countries,
  OnexZip,
  OnexPhone,
  OnexAlert,
  Notifications,
  UsTerritories,
  type USTerritories,
} from '@primerica/onex-ui-lib';
import { $t } from '@/i18n/i18n';

const componentOptions: ComponentOptions = {
  name: 'EditContactInfo',
  components: {
    MessageDialog,
    OnexButton,
    OnexEmail,
    OnexAddressLine1,
    OnexAddressLine2,
    OnexCity,
    OnexState,
    OnexZip,
    OnexPhone,
    OnexAlert,
    LoadingIndicator,
  },
  props: {
    email: {
      type: String,
      required: false,
      default: '',
    },
    phone: {
      type: String,
      required: false,
      default: '',
    },
    address1: {
      type: String,
      required: false,
      default: '',
    },
    address2: {
      type: String,
      required: false,
      default: '',
    },
    city: {
      type: String,
      required: false,
      default: '',
    },
    state: {
      type: String,
      required: false,
      default: '',
    },
    zip: {
      type: String,
      required: false,
      default: '',
    },
    isCanada: {
      type: Boolean,
      required: true,
    },
    editingCategory: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    v$: useVuelidate(),
    loading: false,
    status: false,
    currentState: 'edit',
    show: true,
    allowSave: true,
    // Email
    emailAddress: '',
    confirmEmailAddress: '',
    selectedUpdateEmailAllPolicies: false,
    // Phone
    phoneNumber: '',
    confirmPhoneNumber: '',
    selectedUpdatePhoneAllPolicies: false,
    // Address
    isVerify: true,
    address1Data: '',
    address2Data: '',
    cityData: '',
    stateData: '',
    zipData: '',
    selectedUpdateAddressAllPolicies: false,
    // This is used to determine if save button to show after address verify screen
    addressSelected: '',
    localUSPSFormattedAddress1: '',
    localUSPSFormattedAddress2: '',
    selectedUpdateAll: false,
    showAddressError: false,
    showMsgDialog: false,
    mdiCheckCircleOutline,
    mdiAlertCircleOutline,
    mdiInformationOutline,
    Countries,
    Notifications,
  }),
  validations() {
    return {
      emailAddress: {
        required: requiredIf(this.requiredIfEmail),
      },
      confirmEmailAddress: {
        required: requiredIf(this.requiredIfEmail),
      },

      phoneNumber: {
        required: requiredIf(this.requiredIfPhone),
      },
      confirmPhoneNumber: {
        required: requiredIf(this.requiredIfPhone),
      },
      address1Data: {
        required: requiredIf(this.requiredIfAddress),
      },
      address2Data: {},
      cityData: {
        required: requiredIf(this.requiredIfAddress),
      },
      stateData: {
        required: requiredIf(this.requiredIfAddress),
      },
      zipData: {
        required: requiredIf(this.requiredIfAddress),
      },
    };
  },
  computed: {
    ...mapStores(useGlobalStore, usePolicyStore),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, {
      policies: 'policies',
      addressVerification: 'addressVerification',
      addressUpdateSuccess: 'addressUpdateSuccess',
      policyOwner: 'policyOwner',
      currentPolicy: 'currentPolicy',
      contactDetailsPanel: 'contactDetailsPanel',
      editContactInfo: 'editContactInfo',
      successResponseUpdateContactInfo: 'successResponseUpdateContactInfo',
      errorResponseUpdateContactInfo: 'errorResponseUpdateContactInfo',
    }),
    enableSave() {
      let enableBtn = true;
      if (this.editingCategory === 'email') {
        const hasEmailErrors = [this.v$.emailAddress, this.v$.confirmEmailAddress].some(
          (f) => f.$anyError
        );
        if (
          hasEmailErrors ||
          this.emailAddress.length === 0 ||
          this.confirmEmailAddress.length === 0 ||
          this.emailAddress !== this.confirmEmailAddress
        ) {
          enableBtn = false;
        }
      } else if (this.editingCategory === 'phone') {
        const hasPhoneErrors = [this.v$.phoneNumber, this.v$.confirmPhoneNumber].some(
          (f) => f.$anyError
        );
        if (
          hasPhoneErrors ||
          this.phoneNumber.length !== 10 ||
          this.confirmPhoneNumber.length !== 10 ||
          this.phoneNumber !== this.confirmPhoneNumber
        ) {
          enableBtn = false;
        }
      } else if (this.editingCategory === 'address') {
        const hasAddressErrors = [
          this.v$.address1Data,
          this.v$.cityData,
          this.v$.stateData,
          this.v$.zipData,
        ].some((f) => f.$anyError);
        if (
          this.isVerify &&
          (hasAddressErrors ||
            // this.v$.address1Data.$error ||
            //   this.v$.address2Data.$error ||
            //   this.v$.cityData.$error ||
            //   this.v$.stateData.$error ||
            //   this.v$.zipData.$error ||
            this.address1Data === '' ||
            this.cityData === '' ||
            this.stateData === '' ||
            this.zipData === '')
        ) {
          enableBtn = false;
        } else if (this.isVerify === false && this.addressSelected === '') {
          enableBtn = false;
        }
      }
      return enableBtn && this.allowSave;
    },
    errorNavigateDirectlyToEachPolicy() {
      if (this.editingCategory === 'email') {
        return this.$t('L_Navigate_directly_to_each_policy_displayed_below_email'); // email
      } else if (this.editingCategory === 'phone') {
        return this.$t('L_Navigate_directly_to_each_policy_displayed_below_phone'); // mobile
      } else if (this.editingCategory === 'address') {
        return this.$t('L_Navigate_directly_to_each_policy_displayed_below_homeaddress'); // address
      }
      return '';
    },
    getTerritories(): USTerritories[] {
      return [
        UsTerritories.AMERICAN_SAMOA,
        UsTerritories.GUAM,
        UsTerritories.NORTHERN_MARIANA_ISLANDS,
        UsTerritories.PUERTO_RICO,
        UsTerritories.VIRGIN_ISLANDS,
      ];
    },
    isMultiPolicy() {
      if (this.policies?.length > 1) {
        return true;
      }
      return false;
    },
    isSuccessEdit() {
      if (
        this.successResponseUpdateContactInfo &&
        this.successResponseUpdateContactInfo.length > 0
      ) {
        return true;
      } else if (
        this.errorResponseUpdateContactInfo &&
        this.errorResponseUpdateContactInfo.length > 0
      ) {
        return false;
      }
      return true;
    },
    updateDialogType() {
      if (this.isSuccessEdit) {
        return 'success';
      }
      return 'error';
    },
    updateDialogMessage() {
      if (this.isSuccessEdit) {
        if (this.editingCategory === 'email') {
          // email
          return this.$t(
            'L_your_email_address_has_been_updated_successfully_for_the_following_policies'
          );
        } else if (this.editingCategory === 'phone') {
          // mobile
          return this.$t(
            'L_your_phone_number_has_been_updated_successfully_for_the_following_policies'
          );
        } else if (this.editingCategory === 'address') {
          // address
          return this.$t(
            'L_your_home_address_has_been_updated_successfully_for_the_following_policies'
          );
        }
      }
      if (this.editingCategory === 'email') {
        // email
        return this.$t(
          'L_there_was_error_updating_your_new_email_address_for_the_following_policies'
        );
      } else if (this.editingCategory === 'phone') {
        // mobile
        return this.$t(
          'L_there_was_error_updating_your_new_phone_number_for_the_following_policies'
        );
      } else if (this.editingCategory === 'address') {
        // address
        return this.$t(
          'L_there_was_error_updating_your_new_home_address_for_the_following_policies'
        );
      }
      return '';
    },
    updateDialogTitle() {
      if (this.isSuccessEdit) {
        if (this.editingCategory === 'email') {
          // email
          return this.$t('L_Email_address_has_been_updated_successfully');
        } else if (this.editingCategory === 'phone') {
          // mobile
          return this.$t('L_Phone_number_has_been_updated_successfully');
        } else if (this.editingCategory === 'address') {
          // address
          return this.$t('L_address_has_been_updated_successfully');
        }
      }
      if (this.editingCategory === 'email') {
        // email
        return this.$t(
          'L_there_was_error_updating_your_new_email_address_for_the_following_policies'
        );
      } else if (this.editingCategory === 'phone') {
        // mobile
        return this.$t(
          'L_there_was_error_updating_your_new_phone_number_for_the_following_policies'
        );
      } else if (this.editingCategory === 'address') {
        // address
        return this.$t(
          'L_there_was_error_updating_your_new_home_address_for_the_following_policies'
        );
      }
      return '';
    },
    updateDialogPolicies() {
      if (this.isSuccessEdit) {
        return this.successResponseUpdateContactInfo;
      }
      return this.errorResponseUpdateContactInfo;
    },
    checkBoxLabel() {
      if (this.editingCategory === 'email') {
        // email
        return this.$t('L_Update_email_address_for_all_my_policies');
      } else if (this.editingCategory === 'phone') {
        // mobile
        return this.$t('L_Update_phone_number_for_all_my_policies');
      } else if (this.editingCategory === 'address') {
        // address
        return this.$t('L_Update_home_address_for_all_my_policies');
      }
      return '';
    },
    addressHeaderLabel() {
      if (this.isVerify) {
        return this.$t('L_We_may_use_this_address_to_contact_you_regarding_your_life_policy');
      }
      return this.$t('L_select_which_address_you_want_to_use_from_the_following');
    },
    formattedZip() {
      const { zip } = this.addressVerification;
      if (zip && zip.length > 5) {
        return `${zip.substr(0, 5)}-${zip.substr(5)}`;
      }
      return zip;
    },
  },
  methods: {
    ...mapActions(usePolicyStore, {
      setContactInfoEdit: 'setContactInfoEdit',
    }),
    requiredIfEmail(value: string) {
      if (this.editingCategory !== 'email') return true;
      return value.trim().length > 0 || this.$t('L_the_value_is_required');
    },

    requiredIfPhone(value: string) {
      if (this.editingCategory !== 'phone') return true;
      return value.trim().length > 0 || this.$t('L_the_value_is_required');
    },

    requiredIfAddress(value: string) {
      if (this.editingCategory !== 'address') return true;
      return value.trim().length > 0 || this.$t('L_the_value_is_required');
    },
    async clickSaveChanges() {
      if (this.enableSave === false) {
        this.v$.$touch();
        return;
      }
      this.allowSave = false;
      // Existing data
      const reqObj = {
        address1: this.address1,
        address2: this.address2,
        city: this.city,
        state: this.state,
        zip: this.zip,
        phone: this.phone,
        email: this.email,
        updateAll: this.selectedUpdateAll,
      };
      // Update the portion that was modified
      if (this.editingCategory === 'email') {
        reqObj.email = this.emailAddress;
      } else if (this.editingCategory === 'phone') {
        reqObj.phone = this.phoneNumber;
      } else if (this.editingCategory === 'address') {
        if (this.addressSelected === 'useUsps') {
          reqObj.address1 = this.addressVerification.address1;
          reqObj.address2 = this.addressVerification.address2;
          reqObj.city = this.addressVerification.city;
          reqObj.state = this.addressVerification.state;
          reqObj.zip = this.addressVerification.zip;
        } else {
          //  (this.addressSelected === 'userEntered') && when isVerify === true i.e. during user data entry
          reqObj.address1 = this.address1Data;
          reqObj.address2 = this.address2Data;
          reqObj.city = this.cityData;
          reqObj.state = this.stateData;
          reqObj.zip = this.zipData;
        }
      }
      // Following section is to handle empty data for email or phone on the save.
      if (reqObj.email === '') {
        reqObj.email =
          this.currentPolicy?.data?.clientEmailaddress ||
          this.policyOwner?.email ||
          this.customerProfile.email;
      }
      if (reqObj.phone === '') {
        reqObj.phone =
          this.currentPolicy?.data?.phoneNumber ||
          this.policyOwner?.address.phone ||
          this.customerProfile.mobilePhone;
      }

      // For email and phone update the data
      if (this.editingCategory === 'email' || this.editingCategory === 'phone') {
        // This call is used for verification (addressMatched: true | false)  and update .
        await this.policyStore.updateContactInfo(reqObj);
        if (this.addressVerification === 'error') {
          // TODO add way to show error in front end
          this.allowSave = true;
          this.currentState = 'edit';
        } else {
          this.currentState = 'save';
        }
      } else if (this.editingCategory === 'address') {
        if (this.currentPolicy.isCanadaPolicy) {
          await this.policyStore.updateContactInfo(reqObj);
          if (this.addressVerification === 'error') {
            // TODO add way to show in front end
            this.allowSave = true;
            this.currentState = 'edit';
          } else {
            this.currentState = 'save';
          }
        } else if (this.isVerify === true) {
          await this.policyStore.verifyContactInfo(reqObj);
          // Let user retry putting address again
          if (this.addressVerification === 'error') {
            this.showAddressError = true;
            this.allowSave = true;
            this.isVerify = true;
          } else {
            this.showAddressError = false;
            // Success backend call for address API
            this.allowSave = true;
            this.isVerify = false;
            this.localUSPSFormattedAddress1 = `${this.addressVerification.address1} ${this.addressVerification.address2}`;
            this.localUSPSFormattedAddress2 = `${this.addressVerification.city},${this.addressVerification.state} ${this.formattedZip}`;
          }
          // This is edit because user will have to select USPS or self entered address
          this.currentState = 'edit';
        } else {
          // US users after verify
          await this.policyStore.updateContactInfo(reqObj);
          if (this.addressVerification === 'error') {
            this.allowSave = true;
            this.currentState = 'edit';
          } else {
            this.currentState = 'save';
          }
        }
      }
      if (this.currentState === 'save') {
        this.showMsgDialog = true;
      }
      const successPolicyArray = this.successResponseUpdateContactInfo;
      const currentPolicyNum = this.currentPolicy.contractId;
      // policyNumber: this.currentPolicy.contractId,
      if (
        this.currentState === 'save' &&
        successPolicyArray.length > 0 &&
        successPolicyArray.indexOf(currentPolicyNum) > -1
      ) {
        await this.policyStore.getPolicies();
      }
    },
    async closeEditContact() {
      this.loading = true;
      this.policyStore.addressVerification = null;
      this.policyStore.addressUpdateSuccess = false;
      this.showMsgDialog = false;
      try {
        await this.policyStore.getPolicies();
        await this.policyStore.getPolicyOverview();
      } catch (_error) {
        /* empty */
      } finally {
        this.$emit('closeeditcontact');
        this.loading = false;
      }
    },
    notSameAsEmail(value: string) {
      return value.toLowerCase() === this.emailAddress.toLowerCase() || $t('L_confirm_email_match');
    },
    notSameAsPhoneValidation(value: string) {
      return (
        value.replace(/\D/g, '') === this.phoneNumber.toLowerCase() ||
        $t('L_phone_number_must_match')
      );
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
/* Align the checkbox wrapper and the label text to the top */
:deep(.v-selection-control) {
  align-items: flex-start !important;
  padding-top: 4px;
  /* Optional: nudges the text down slightly to match the box */
}

/* Align the SVG icon to the top of its own container wrapper */
:deep(.v-selection-control__wrapper) {
  height: auto !important;
  min-height: unset !important;
  align-items: flex-start !important;
}

.pinkBkgrndWithRedTop {
  background-color: #ffecec;
  border-top: 4px solid red;
  padding: 10px 10px 10px 15px;
  border-bottom: 1px solid gray;
}

.ltgreenBkgrndWithGreenTop {
  background-color: #d8fcdc;
  border-top: 4px solid green;
  padding: 10px 2px 10px 15px;
  border-bottom: 1px solid gray;
}

.moveToRight {
  float: right !important;
}

.graybutton {
  color: black !important;
  background-color: #b3b3b3 !important;
}

.bluebutton {
  color: #ffffff !important;
  background-color: #063662 !important;
  border: 2px solid #b3b3b3 !important;
}

.whitebutton {
  color: #063662 !important;
  background-color: #ffffff !important;
}

.btnFormat {
  width: 260px;
}

.btnOKSize {
  width: 40%;
  max-width: 288px;
}

.centerBtnHorizontally {
  margin: auto !important;
}

.divHoldingPolicyForSuccessAndError {
  background-color: #eeeeee;
  padding: 10px 25px 10px 25px;
}

.maxButtonWidth {
  max-width: 275px;
  width: 275px;
  padding-left: 0px;
  padding-right: 0px;
  margin-left: 0px;
  margin-right: 0px;
}

.primarybutton {
  color: #ffffff !important;
  background-color: #063562 !important;
}

.blue-border {
  border: solid 2px #2196f3;
}

.gray-border {
  border: solid 2px #eeeeee;
}

.heading_two {
  line-height: 22px;
}

.fullHorizontalStretch {
  margin-left: -20px !important;
  margin-right: -20px !important;
}

.v-messages__message {
  line-height: 1.2em !important;
}
</style>
